import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#222] bg-[#050505]" data-testid="footer">
      <div className="px-6 md:px-12 pt-20 pb-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-16">
          <div className="max-w-md">
            <div className="font-heading text-2xl mb-4">
              Bartending <span className="italic text-gold">Iz</span> Life
            </div>
            <p className="text-[#a0a0a0] font-light text-sm leading-relaxed">
              Premium mobile bartending for the moments that matter. We bring the bar, the craft,
              and the celebration to you.
            </p>
          </div>
          <div className="flex flex-col gap-3 text-sm">
            <span className="text-xs uppercase tracking-[0.25em] text-gold mb-2">Contact</span>
            <a href="tel:+16464009752" className="text-white/85 hover:text-gold transition-colors" data-testid="footer-phone">
              + 1 (646) 400-9752
            </a>
            <a href="mailto:support@bartendingizlife.com" className="text-white/85 hover:text-gold transition-colors" data-testid="footer-email">
              support@bartendingizlife.com
            </a>
            <span className="text-white/85">New York City</span>
          </div>
          <a
            href="#top"
            data-testid="footer-back-to-top"
            className="self-start inline-flex items-center gap-2 border border-[#222] hover:border-gold px-5 py-3 text-xs uppercase tracking-[0.2em] text-white hover:text-gold transition-all duration-300"
          >
            Back to top <ArrowUp size={14} />
          </a>
        </div>

        <div className="relative overflow-hidden border-t border-[#222] pt-10">
          <h2 className="font-heading text-4xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[8rem] leading-[0.85] tracking-tight text-white select-none">
            Bartending Iz Life
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-3 mt-8 text-xs text-[#5a5a5a]">
          <span>© {new Date().getFullYear()} Bartending Iz Life. All rights reserved.</span>
          <span>Crafted with spirit in NYC · Please drink responsibly.</span>
        </div>
      </div>
    </footer>
  );
}
